import { gql, useMutation } from '@apollo/client'
import { useAlert, useNotification } from '@btime/react-messager'
import { useTranslation } from 'react-i18next'
import { triggersClient } from '../../../../utils/apollo/api'
import { useTableActions } from '../../../../components/tables/MultiSelectTableContext'

const MUTATION = gql`
  mutation RequeueFailedTasks {
    requeueFailedTasks
  }
`

export const useRequeueFailedTasks = () => {
  const [request, state] = useMutation(MUTATION, {
    refetchQueries: ['TriggerCalls', 'TriggerCallsCount'],
    client: triggersClient
  })
  const notify = useNotification()
  const modal = useAlert()
  const { clearSelection } = useTableActions()
  const { t } = useTranslation()

  const handleRequest = () => {
    if (!modal.confirm({ title: t('retry_failed_confirm') })) return false

    return request().then(resp => {
      if (!resp.errors) {
        if (clearSelection) clearSelection()
        const count = resp.data.requeueFailedTasks
        notify.success({ title: `${count} tarefa(s) reexecutada(s)!` })
      } else {
        notify.error({ title: 'Não foi possivel reexecutar as tarefas falhadas' })
      }
    })
  }

  return [handleRequest, state]
}
